<script lang="ts">
  import LocationsList from './LocationsList.svelte'
  import { indicateMatch } from '../lib/actions/search-place'
  import type { Filter } from '../global'

  export let areas: Array<Filter.Locations>
  export let query: string
  export let noResultsFor: string

  $: transformed = indicateMatch(query, areas)
</script>

{#if areas.length > 0}
  <LocationsList areas={transformed} />
{:else}
  <div class="pt-2">
    {noResultsFor} "{query}"
  </div>
{/if}
